<template>
  <PSComponentTabCard />
</template>

<script>
export default {
    data() {
        return {
        }
    }
}
</script>
